import { NavigationNode } from '~/lib/data-contract';
import { NavigationItem } from '../navigation-item/navigation-item.component';
import styles from './item-list.module.css';
import { clsx } from 'clsx';
import { memo } from 'react';

type Props = {
    items: NavigationNode[];
    onMenuClick?: (item: NavigationNode | null) => void;
    isSubList?: boolean;
    selectedItem?: NavigationNode | null;
};

const ItemList = memo(({ items, onMenuClick, isSubList, selectedItem }: Props) => {
    return (
        <ul
            className={clsx(styles.root, {
                [styles.subList]: isSubList,
                [styles.columns]: items.length > 10,
            })}
        >
            {items.map((item, index) => {
                const isActive = selectedItem?.id === item.id;
                return (
                    <li key={`${item.id}-${index}`} className={styles.item}>
                        <NavigationItem
                            item={item}
                            isActive={isActive}
                            onMenuClick={() => {
                                isActive ? onMenuClick?.(null) : onMenuClick?.(item);
                            }}
                            isSubItem={isSubList}
                        />
                    </li>
                );
            })}
        </ul>
    );
});

ItemList.displayName = 'ItemList';
export default ItemList;
